import { useEffect } from "react"
import { useLazyGetPhaseNodetailsQuery } from "../../../services/announceElection"
import LeftMenu from "../../AnalyticsModule/Left"
import EpbDownloadStatusByRecordOfficer from "../../Officers/RecordOfficer/EpbDownloadStatusByRecordOfficer"
import DownloadInstruction from "../Dashboard/DownloadInstruction"

function RecordOfficerDashboard() {
  const [phaseNo,datap] = useLazyGetPhaseNodetailsQuery()
 
  useEffect(()=>{
    phaseNo().then((res)=>{
      var data = []
  res?.data?.payload?.map((item)=>{
    data.push(item?.phaseNo)
  })
  let string = JSON.stringify(data)
  localStorage.setItem("phaseList",string)
    })
  },[])

  return (
    <>
      <LeftMenu>
      <EpbDownloadStatusByRecordOfficer />
      <DownloadInstruction />
      </LeftMenu>
    </>
  )
}

export default RecordOfficerDashboard
